(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SHOW_AFTER = 400;

  function initBackToTop(btn) {
    if (btn.dataset.cbtInitialized === 'true') return;
    btn.dataset.cbtInitialized = 'true';

    var ticking = false;

    function update() {
      btn.classList.toggle('cbt-sc-visible', window.scrollY > SHOW_AFTER);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function onClick() {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', onClick);
    update();

    btn.cbtDestroy = function () {
      window.removeEventListener('scroll', onScroll);
      btn.removeEventListener('click', onClick);
      btn.dataset.cbtInitialized = 'false';
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.custom-back-to-top').forEach(initBackToTop);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var btn = evt.target.querySelector('.custom-back-to-top');
    if (btn && btn.cbtDestroy) btn.cbtDestroy();
  });
})();
